import React, { useState } from 'react';
import { Modal, OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import BoldButton from '../../Common/BoldButton';
import FilterInput, { textSatisfiesFilter } from '../../FilterInput';
import { TransportDto } from '../../../requests/useGetTransports';

interface TransportSearchModalProps {
  visible: boolean;
  transports: TransportDto[];
  assignedTransportIds: Set<string>;
  onSelect: (transport: TransportDto) => void;
  onCancel: () => void;
}

const alphabeticallyByName = (a: TransportDto, b: TransportDto) => a.name.localeCompare(b.name);

export const TransportSearchModal = ({ visible, transports, assignedTransportIds, onSelect, onCancel }: TransportSearchModalProps) => {
  const [filterText, setFilterText] = useState('');

  const containsFilterText = (transport: TransportDto) => {
    const satisfiesFilter = textSatisfiesFilter(filterText);
    return satisfiesFilter(transport.name) || satisfiesFilter(transport.number ?? '');
  };

  return (
    <Modal show={visible} onHide={onCancel} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Select Transport to Merge With</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <FilterInput
            placeholder="Filter by name or number"
            onFilterTextChange={setFilterText}
          />
        </div>
        {transports.length === 0 ? (
          <p>No existing transports found.</p>
        ) : (
          <Table bordered hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Number</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {transports.filter(containsFilterText).sort(alphabeticallyByName).map(transport => {
                const isAssigned = assignedTransportIds.has(transport.id);
                return (
                  <tr key={transport.id}>
                    <td>{transport.name}</td>
                    <td>{transport.number || '-'}</td>
                    <td>
                      <OverlayTrigger
                        placement="top"
                        overlay={isAssigned
                          ? <Tooltip>This transport is already assigned to this site.</Tooltip>
                          : <></>}
                      >
                        <span className="d-inline-block">
                          <BoldButton
                            className="btn-ghost-primary"
                            onClick={() => onSelect(transport)}
                            disabled={isAssigned}
                            style={{ pointerEvents: isAssigned ? 'none' : 'auto' }}
                          >
                            Select
                          </BoldButton>
                        </span>
                      </OverlayTrigger>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <BoldButton className="btn-ghost-secondary" onClick={onCancel}>
          Cancel
        </BoldButton>
      </Modal.Footer>
    </Modal>
  );
};
